var Menu = function() {

	var comp = $('[data-component="menu"]');

	this.init = function() {

		toggleSubmenu();

		toggleSubitem();

		toggleMenuMobile();

	}

	function toggleMenuMobile() {
		$('.menu-mobile').on('click', function() {
			var menu = $('.menu-holder');

			if(menu.length > 0 && !menu.hasClass('open')){
				TweenMax.set(menu, {height: 'auto'} );
				TweenMax.from(menu, .8, { height: 0, ease: Quint.easeOut });

				menu.addClass('open');
				$(this).addClass('opened');
			} else {
				TweenMax.to(menu, .8, { height: 0, ease: Quint.easeOut });
				$('.submenu-list').removeClass('open');
				$('.subitem-list').removeClass('open');
				TweenMax.to($('.submenu-list'), .3, { height: 0, ease: Quint.easeOut });
				TweenMax.to($('.subitem-list'), .3, { height: 0, ease: Quint.easeOut });
				menu.removeClass('open');
				$(this).removeClass('opened');
			}
		});
	}

	function toggleSubmenu() {
		if ($(document).width() > 768) {
			comp.find('.menu-item, .profile-holder').hover(
				function(){

					var submenu = $(this).find('.submenu-list');

					console.log($(this));

					if($(this).hasClass('profile-holder')) {

						console.log('test');

						if(submenu.length > 0){
							TweenMax.to(submenu, .8, { top: '80px', opacity: 1, autoAlpha: 1, ease: Quint.easeOut });
						}

					} else {

						console.log('dsda');

						if(submenu.length > 0){
							TweenMax.to(submenu, .8, { top: '60px', opacity: 1, autoAlpha: 1, ease: Quint.easeOut });
						}

					}

				},
				function(){

					var submenu = $(this).find('.submenu-list');

					if(submenu.length > 0){
						TweenMax.to(submenu, .4, { top: '40px', opacity: 0, autoAlpha: 0, ease: Quint.easeOut, });
					}

				}
			);
		} else {
			comp.find('.menu-item, .profile-holder').on('click', function(){
					var submenu = $(this).find('.submenu-list');

					if(submenu.length > 0 && !submenu.hasClass('open')){
						$('.submenu-list').removeClass('open');
						$('.subitem-list').removeClass('open');
						TweenMax.to($('.subitem-list'), .3, { height: 0, ease: Quint.easeOut });
						TweenMax.to($('.submenu-list'), .3, { height: 0, ease: Quint.easeOut,
							onComplete: function() {
								TweenMax.set(submenu, {height: 'auto'} );
								TweenMax.from(submenu, .8, { height: 0, ease: Quint.easeOut });
								submenu.addClass('open');
							}
						});
					} else {
						TweenMax.to(submenu, .8, { height: 0, ease: Quint.easeOut });

						submenu.removeClass('open');
					}
				}
			);
		}

	}

	function toggleSubitem() {
		if ($(document).width() > 768) {
			comp.find('.submenu-item').hover(
				function(){

					var subitem = $(this).find('.subitem-list');

					if(subitem.length > 0){
						TweenMax.to(subitem, .8, { opacity: 1, autoAlpha: 1, ease: Quint.easeOut });
					}

				},
				function(){

					var subitem = $(this).find('.subitem-list');

					if(subitem.length > 0){
						TweenMax.to(subitem, .4, { opacity: 0, autoAlpha: 0, ease: Quint.easeOut	});
					}

				}
			)
		} else {
			comp.find('.submenu-item').on('click', function(e){
					var subitem = $(this).find('.subitem-list');
					TweenMax.to($('.subitem-list'), .8, { height: 0, ease: Quint.easeOut });

					if(subitem.length > 0 && !subitem.hasClass('open')){
						$('.subitem-list').removeClass('open');
						TweenMax.to($('.subitem-list'), .3, { height: 0, ease: Quint.easeOut,
							onComplete: function() {
								TweenMax.set(subitem, {height: 'auto'} );
								TweenMax.from(subitem, .8, { height: 0, ease: Quint.easeOut });
								subitem.addClass('open');
							}
						});
					} else {
						TweenMax.to(subitem, .8, { height: 0, ease: Quint.easeOut });

						subitem.removeClass('open');
					}

					e.stopPropagation()
				}
			);
		}
	}

	return this.init();

}
